import { ProvideCalculatorEventArgs as ProvideCalculatorEventArgs_internal } from "./ProvideCalculatorEventArgs";
/**
 * Event arguments for the ProvideCalculator event.
*/
var IgrProvideCalculatorEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrProvideCalculatorEventArgs() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrProvideCalculatorEventArgs.prototype.createImplementation = function () {
        return new ProvideCalculatorEventArgs_internal();
    };
    Object.defineProperty(IgrProvideCalculatorEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrProvideCalculatorEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrProvideCalculatorEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    Object.defineProperty(IgrProvideCalculatorEventArgs.prototype, "calculator", {
        /**
         * Gets or sets the summary calculator to use for this summary.
        */
        get: function () {
            return this.i.a;
        },
        set: function (v) {
            this.i.a = v;
        },
        enumerable: true,
        configurable: true
    });
    return IgrProvideCalculatorEventArgs;
}());
export { IgrProvideCalculatorEventArgs };
//# sourceMappingURL=igr-provide-calculator-event-args.js.map
